import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=a38fd700"
import script from "./CommentCard.vue?vue&type=script&lang=js"
export * from "./CommentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports